import {
    useCallback,
} from 'react'

import {
    useMutation,
} from '@tanstack/react-query'

import simpleApi from 'app/services/simpleApi'
import {
    useJWTToken,
} from 'app/Auth'
import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import requests from 'app/requests/Contact/Contact.requests'
import {
    ContactDuplication,
} from '../Contacts.types'

type ContactParams = { contactName: string, email: string }

type Props = {
    onSuccess: (data: ContactDuplication[]) => void
}

const useContactDuplicationCheck = ({
    onSuccess: onSuccessAction,
}: Props) => {
    const token = useJWTToken()

    const {
        onStartSaving,
        onError: onFailedRequest,
        removePendingStatus,
    } = useHandleStatusRequest({
        id: 'ContactDuplicationCheck',
    })

    const onSuccess = useCallback((data: ContactDuplication[]) => {
        removePendingStatus()
        onSuccessAction(data)
    }, [
        removePendingStatus,
        onSuccessAction,
    ])

    const onError = useCallback((err) => {
        onFailedRequest(err)
    }, [onFailedRequest])

    const {
        mutate: checkDuplication,
    } = useMutation({
        mutationFn: (data: ContactParams) => {
            return simpleApi({
                ...requests.duplication({
                    data,
                }),
                token,
            })
        },
        onSuccess,
        onError,
    })

    return useCallback((contactParams: ContactParams) => {
        onStartSaving('Checking Database for similar contacts')
        checkDuplication(contactParams)
    }, [
        checkDuplication,
        onStartSaving,
    ])
}

export default useContactDuplicationCheck
